const FIRST_FRAME_TIME = 1
const MAX_PREVIEW_TIME = 2

function getPreviewFrameTime(duration) {
  const videoDuration = Number(duration)
  if (!Number.isFinite(videoDuration) || videoDuration <= 0) {
    return FIRST_FRAME_TIME
  }

  const representativeTime = Math.max(FIRST_FRAME_TIME, videoDuration * 0.05)
  return Math.min(MAX_PREVIEW_TIME, representativeTime, Math.max(0, videoDuration - 0.05))
}

export function getVideoFirstFrameUrl(url) {
  if (url === null || url === undefined) {
    return ''
  }
  const value = String(url).trim()
  if (!value || value.indexOf('#') !== -1) {
    return value
  }
  return value + '#t=' + FIRST_FRAME_TIME
}

export function prepareVideoFirstFrame(event) {
  const video = event && (event.currentTarget || event.target)
  if (!video) {
    return
  }
  try {
    const targetTime = getPreviewFrameTime(video.duration)
    if (Math.abs(Number(video.currentTime) - targetTime) > 0.05) {
      video.currentTime = targetTime
      return
    }
    video.pause()
  } catch (e) {
    // The media fragment still provides the first-frame fallback.
  }
}



// WEBPACK FOOTER //
// ./src/utils/videoFirstFrame.js